import { render, staticRenderFns } from "./ButtonFile.vue?vue&type=template&id=2399e13a&scoped=true&"
import script from "./ButtonFile.vue?vue&type=script&lang=js&"
export * from "./ButtonFile.vue?vue&type=script&lang=js&"
import style0 from "./ButtonFile.vue?vue&type=style&index=0&id=2399e13a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2399e13a",
  null
  
)

export default component.exports